import { render, staticRenderFns } from "./RentsReport.vue?vue&type=template&id=590c1756&"
import script from "./RentsReport.vue?vue&type=script&lang=js&"
export * from "./RentsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports